export default "__VITE_ASSET__DnedhMK$__"